package com.tovtalk.domain.entity

import kotlin.time.Instant

/**
 * User Entity - מייצג משתמש במערכת
 */
data class User(
    val id: Int,
    val firebaseUid: String,
    val identity: String,
    val fullname: String,
    val username: String,
    val email: String?,
    val profilePhoto: String?,
    val bio: String?,
    
    // Stats
    val followerCount: Int = 0,
    val followingCount: Int = 0,
    val totalPostLikesCount: Int = 0,
    
    // Coins
    val coinWallet: Int = 0,
    val coinCollectedLifetime: Int = 0,
    val coinGiftedLifetime: Int = 0,
    val coinPurchasedLifetime: Int = 0,
    
    // Status
    val isVerified: Boolean = false,
    val isFreeze: Boolean = false,
    val isReadOnly: Boolean = false,
    val showFeedAds: Boolean = false,
    val showProfileAds: Boolean = false,
    val isModerator: Boolean = false,
    
    // Settings
    val appLanguage: String = "en",
    val whoCanViewPost: WhoCanViewPost = WhoCanViewPost.EVERYONE,
    val showMyFollowing: Boolean = true,
    val receiveMessage: Boolean = true,
    
    // Notifications
    val notifyPostLike: Boolean = true,
    val notifyPostComment: Boolean = true,
    val notifyFollow: Boolean = true,
    val notifyMention: Boolean = true,
    val notifyGiftReceived: Boolean = true,
    val notifyChat: Boolean = true,
    val notifyMessageRequests: Boolean = true,

    // Location
    val country: String? = null,
    val countryCode: String? = null,
    val region: String? = null,
    val city: String? = null,
    val lat: Double? = null,
    val lon: Double? = null,
    
    // Kashrut (1=דברי תורה, 2=כשר, 3=עלול להכיל נשים, 4=תוכן עם נשים)
    val kashrutLevel: Int? = null,
    /** רמת כשרות תוכן (ליוצרים). להצגה בפרופיל; אם null – לא להציג תגית. */
    val artistType: Int? = null,
    val consumptionCategoryIds: List<Int>? = null,
    val uploadCategoryId: Int? = null,

    // External source IDs and auto-pull
    val instagramId: String? = null,
    val whatsappStatusId: String? = null,
    val youtubeChannelId: String? = null,
    val autoPullInstagram: Boolean = false,
    val autoPullWhatsappStatus: Boolean = false,
    val autoPullYoutube: Boolean = false,

    /** When auto-pulling from source, also update profile photo and bio. */
    val autoUpdateProfileInstagram: Boolean = false,
    val autoUpdateProfileWhatsappStatus: Boolean = false,
    val autoUpdateProfileYoutube: Boolean = false,

    // Relationship (עבור משתמשים אחרים)
    val isFollowing: Boolean = false,
    val hasActiveStory: Boolean = false,
    val followStatus: FollowStatus = FollowStatus.NOT_FOLLOWING,
    val isBlocked: Boolean = false,
    
    // Links
    val links: List<UserLink> = emptyList(),
    
    // Timestamps
    val createdAt: Instant,
    val updatedAt: Instant,
    val appLastUsedAt: Instant? = null,
    val usernameChangedAt: Instant? = null,
)

/**
 * User Link - קישור חיצוני של המשתמש
 */
data class UserLink(
    val id: Int,
    val title: String,
    val url: String,
    val linkType: LinkType
)

/**
 * סוגי קישורים
 */
enum class LinkType {
    WEBSITE,
    INSTAGRAM,
    YOUTUBE,
    SHOP,
    OTHER
}

/**
 * מי יכול לראות פוסטים
 */
enum class WhoCanViewPost(val value: Int) {
    EVERYONE(0),
    FOLLOWERS_ONLY(1);
    
    companion object {
        fun fromInt(value: Int) = entries.find { it.value == value } ?: EVERYONE
    }
}

/**
 * סטטוס Follow
 */
enum class FollowStatus(val value: Int) {
    NOT_FOLLOWING(0),
    FOLLOWING(1),
    REQUESTED(2);
    
    companion object {
        fun fromInt(value: Int) = entries.find { it.value == value } ?: NOT_FOLLOWING
    }
}

/**
 * Login Method
 */
enum class LoginMethod {
    EMAIL,
    GOOGLE,
    APPLE
}
